import request from "@/router/axios"
export const sync = () => {
    return request({
        url: `/api/basis/holiday/sync`,
        method: 'get',
    })
}
export const add = (data) => {
    return request({
        url: `/api/basis/holiday/add`,
        method: 'post',
        data: data
    })
}
export const edit = (data) => {
    return request({
        url: `/api/basis/holiday/edit`,
        method: 'post',
        data: data
    })
}